import React from 'react'

const SvgAdverseReactionFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <g clipPath='url(#adverse-reaction-filled_svg__clip0_101581_95)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M20.052 11.151c-.065-.296-.362-3.149-.362-3.149 0-2.5-3.32-6.002-7.592-6.002C7.037 2 4 5.583 4 10.003c0 .78.113 1.533.323 2.245.146.496.35.919.586 1.37 1.381 2.98 1.393 4.446 1.172 5.136-.107.333-.216.674-.282.976-.062.282-.125.681-.013 1.082.137.492.486.828.923 1.005.37.15.795.184 1.2.183l5.584-.015.772-2.296h2.494c.755 0 1.807-.313 2.22-1.356.237-.601.384-1.315.492-1.878l.06-.327.001-.002c.03-.16.056-.303.084-.44.036-.18.063-.29.08-.349a2.72 2.72 0 01.269-.2l.177-.12c.143-.1.434-.301.63-.602.112-.172.208-.395.225-.664a1.406 1.406 0 00-.153-.726c-.546-1.086-.703-1.462-.792-1.874zM11.8 7.6a.8.8 0 100-1.6.8.8 0 000 1.6zm.8 2.4a.8.8 0 11-1.6 0 .8.8 0 011.6 0zm2.2-1.4a.8.8 0 100-1.6.8.8 0 000 1.6zm.8 1.6a.8.8 0 11-1.6 0 .8.8 0 011.6 0zm-.8 3.2a.8.8 0 100-1.6.8.8 0 000 1.6zm-2.2-.2a.8.8 0 11-1.6 0 .8.8 0 011.6 0zm-3.8 0a.8.8 0 100-1.6.8.8 0 000 1.6zm.8-3.2A.8.8 0 118 10a.8.8 0 011.6 0zm-.8-1.6a.8.8 0 100-1.6.8.8 0 000 1.6z'
      />
    </g>
    <defs>
      <clipPath id='adverse-reaction-filled_svg__clip0_101581_95'>
        <path d='M0 0h24v24H0z' />
      </clipPath>
    </defs>
  </svg>
)

export default SvgAdverseReactionFilled
